import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sale-report',
  templateUrl: './sale-report.component.html',
  styleUrls: ['./sale-report.component.css']
})
export class SaleReportComponent implements OnInit {

  public menu_item_id = '56';
  
  private dp = [];
  rep_list = [];
  branchList = [];
  allStoreList = [];
  storeList = [{ 'store_id': '0', 'store_name': 'الكل', 'store_name_en': 'All' }];

  total = '0'; total_paid = '0'; total_remain = '0';

  displayedColumns = ['invoice_no', 'invoice_date', 'cust_name', 'customer_no', 'total', 'payment_method', 
    'paid', 'remain', 'deliver_date', 'name'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'from_date': new Date(), 'to_date': new Date(), 'employee_no': '0', 'branch_id': '0', 
    'store_id': '0', 'title': 'تقرير المبيعات والتحصيل' };

  Sale_Report; Total_Paid; Total_Remain; 
  Total; From_Date; To_Date;
  From_Date_Msg; To_Date_Msg; 

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Sale_Report').subscribe((res: string) => {
      this.Sale_Report = res;
    });
    this.model['title'] = this.Sale_Report;

    translate.get('Total_Paid').subscribe((res: string) => {
      this.Total_Paid = res;
    });

    translate.get('Total_Remain').subscribe((res: string) => {
      this.Total_Remain = res;
    });

    translate.get('Total').subscribe((res: string) => {
      this.Total = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('From_Date_Msg').subscribe((res: string) => {
      this.From_Date_Msg = res;
    });

    translate.get('To_Date_Msg').subscribe((res: string) => {
      this.To_Date_Msg = res;
    });

  }


  ngOnInit() {
    let query = this.queryList.all_repEmp;
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.rep_list = data.data['list'];
        let selObj = { 'employee_no': '0', 'name': 'الكل', 'name_en': 'All' };
        let noRep = { 'employee_no': '-1', 'name': 'بدون مندوب', 'name_en': 'Without Representative' };
        this.rep_list.unshift(noRep);
        this.rep_list.unshift(selObj);
      });

    query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });

    query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'" +
      " AND `branch_auth`.`store_id` = `store`.`store_id`";

    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.allStoreList = data.data['list'];
      });
  }

  filterStore() {
    this.storeList = [{ 'store_id': '0', 'store_name': 'الكل', 'store_name_en': 'All' }];
    this.model['store_id'] = '0';

    if (this.model['branch_id'] != '0') {
      this.allStoreList.forEach(element => {
        if (element.branch_id == this.model['branch_id'])
          this.storeList.push(element);
      });
    }
  }

  search() {
    if (this.model['from_date'] == undefined || this.model['from_date'].toString() == '') {
      alert(this.From_Date_Msg);
      return;
    }

    if (this.model['to_date'] == undefined || this.model['to_date'].toString() == '') {
      alert(this.To_Date_Msg);
      return;
    }

    this.dp = [];
    this.total = '0';
    this.total_paid = '0';
    this.total_remain = '0';

    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate() + ' 00:00:00';
    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate() + ' 23:59:59';

    let obj = { cmd: 'getSaleReport', from_date: from_date, to_date: to_date, 
      employee_no: this.model['employee_no'] };

    if (this.model['branch_id'] == '0') 
      obj['store_list'] = this.allStoreList;
    else {
      if (this.model['store_id'] != '0')
        obj['store_id'] = this.model['store_id'];
      else {
        let allStoreList = [];
        this.storeList.forEach(element => {
          if (element.store_id != '0')
            allStoreList.push({ 'store_id': element.store_id });
        });
        obj['store_list'] = allStoreList;
      }
    }

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        console.log(data);
        if (data.status['type'] == 'success') {
          this.dp = data.status['msg'][0]['list'];

          this.total = data.status['msg'][0]['total'];
          this.total_paid = data.status['msg'][0]['total_paid'];
          this.total_remain = data.status['msg'][0]['total_remain'];
        }
        else
          alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }


  print() {

    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate();
    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate();
      
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.From_Date + ': ' + from_date + '</td><td width="33%"> ' + this.To_Date + ': ' + to_date + '</td></tr>';
    html_data += '<tr><td width="33%"> ' + this.Total + ': ' + this.total + '</td><td width="33%"> ' + this.Total_Paid + ': ' +
      this.total_paid + '</td><td width="33%"> ' + this.Total_Remain + ': ' + this.total_remain + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('sale_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
